// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "attoWallet." + {"54":"2dba66a611e01f2a3ab7","771":"0045ff8a9e0d35dfdcbd"}[chunkId] + ".js";
};